import templateUrl from './divisional-commission-policies-dashboard.component.html';

export const DivisionalCommissionPoliciesDashboardComponent = {
    controller: DivisionalCommissionPoliciesDashboardController,
    controllerAs: "vm",
    templateUrl
}

function DivisionalCommissionPoliciesDashboardController(divisionService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
        divisionService.retrieveDivisions()
            .then(function (divisions) {
                vm.divisions = divisions.filter(function (division) {
                    return division.UseProductCommissionPolicy || division.UseProductLineMultiPlayPolicy;
                });
                vm.division = vm.divisions[0];
            });
    }
}
